(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.shell:mxWizardRoadmap
	 * @module mx.shell
	 * @description
	 * Directive that represents wizard's roadmap.
	 * @param {mx.shell.Wizard} wizard= - A wizard object that should be mapped to directive
	 * @usage <mx-wizard-roadmap wizard="vm.wizard"></mx-wizard-roadmap>
	 */

	angular.module('mx.shell').component('mxWizardRoadmap', {
		bindings: { wizard: '=' },
		controller: WizardRoadmapController,
		controllerAs: 'vm',
		templateUrl: 'components/mx-wizard/mx-wizard-roadmap.html',
	});

	WizardRoadmapController.$inject = ['$scope'];

	function WizardRoadmapController($scope) {
		var vm = this;

		vm.$onInit = function () {
			vm.roadmap = vm.wizard.roadmap;
		};

		$scope.$watchGroup(['vm.wizard.allWizardSteps.length', 'vm.wizard.currentStep'], updateSteps);

		function updateSteps() {
			vm.steps = vm.wizard.allWizardSteps.map(function (step) {
				return {
					Active: step.isCurrent ? true : undefined,
					Title: step.title,
				};
			});
		}
	}
})();
